<template>
  <v-dialog
    transition="dialog-top-transition"
    v-model="dialog"
    @click:outside="$emit('close')"
    @keydown.esc="$emit('close')"
    max-width="600px"
  >
    <v-card>
      <v-card-title>
        <span>{{ $t("add exam") }}</span>
      </v-card-title>
      <v-card-text>
        <v-container class="d-block">
          <v-row class="justify-center">
            <v-col cols="12" sm="6" md="4" lg="6">
              <v-text-field
                v-model="data.name"
                outlined
                :label="$t('name')"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="6">
              <v-text-field
                v-model="data.duration"
                type="number"
                outlined
                :label="$t('duration')"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="6"
              ><date-time-picker
                v-if="dialog"
                @getDate="data.starting_date = $event"
                :label="'starting date'"
              ></date-time-picker>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="6"
              ><date-time-picker
                v-if="dialog"
                @getDate="data.finishing_date = $event"
                :label="'finishing date'"
              ></date-time-picker>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="6">
              <v-text-field
                v-model="data.grade_to_pass"
                type="number"
                outlined
                :label="$t('grade to pass')"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="6">
              <auto-complete
                v-if="dialog"
                @getItem="data.subject_id = $event"
                :data="type == 'edit' ? editData.subject : null"
                :label="'subject'"
                :Store="Subject"
                :isObject="true"
                :clearAutocomplete="clearAuto"
              ></auto-complete>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="6">
              <auto-complete
                v-if="dialog"
                @getItem="data.edu_class_id = $event"
                :data="type == 'edit' ? editData.edu_class : null"
                :label="'edu class'"
                :Store="eduClass"
                :isObject="true"
                :clearAutocomplete="clearAuto"
              ></auto-complete>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="6">
              <v-select
                v-model="data.type"
                :items="items"
                outlined
                item-text="name"
                item-value="value"
                :label="$t('type')"
                required
              ></v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close" color="blue darken-1" text>
          {{ $t("close") }}
        </v-btn>

        <v-btn
          :disabled="disable"
          :loading="createLoader"
          color="blue darken-1"
          text
          @click="create"
        >
          {{ $t("save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { Exams as Store } from "@/store/teacher/exams";
import { Subject } from "@/store/teacher/subjects";
import { eduClass } from "@/store/teacher/eduClass/index";
import dateTimePicker from "./dateTimePicker.vue";
export default {
  components: {
    dateTimePicker,
  },
  props: ["dialog", "editData", "type"],
  data() {
    return {
      Store,
      Subject,
      eduClass,
      data: { finishing_date: null, starting_date: null },
      clearAuto: false,
      page: 1,
      menu1: false,
      menu2: false,
      confirmedPassword: null,
      numberOfKeys: 8,
    };
  },
  methods: {
    create() {
      if (this.type == "create") {
        this.$emit("create", this.data);
        this.data = {};
        this.clearAuto = true;
      } else {
        for (let key in this.data) {
          if (this.data[key] == this.editData[key]) {
            delete this.data[key];
          }
        }
        this.$emit("edit", this.data);
      }
    },
    edit() {
      console.log("you are in edit");
    },
    close() {
      this.data = {};
      this.$emit("close");
    },
  },
  computed: {
    items() {
      return [
        {
          name: this.$t("makka"),
          value: "makka",
        },
        {
          name: this.$t("mountain"),
          value: "mountain",
        },
        {
          name: this.$t("rivers"),
          value: "rivers",
        },
        {
          name: this.$t("desert"),
          value: "desert",
        },
        {
          name: this.$t("city"),
          value: "city",
        },
        {
          name: this.$t("madina"),
          value: "madina",
        },
        {
          name: this.$t("islamic"),
          value: "islamic",
        },
      ];
    },
    createLoader() {
      return Store.postState.loading;
    },

    disable() {
      for (let key in this.data) {
        if (
          this.data[key] == null ||
          this.data[key] == "" ||
          this.data.starting_date == null ||
          this.data.finishing_date == null
        ) {
          return true;
        }
      }
      if (
        Object.keys(this.data).length != this.numberOfKeys &&
        this.type == "create"
      ) {
        return true;
      }
      return false;
    },
  },
  created() {
    Subject.get({ page: 1 });
    eduClass.get({ page: 1 });
  },
  watch: {
    editData(val) {
      this.data = { ...val };
    },
  },
};
</script>
